// extracted by mini-css-extract-plugin
module.exports = {"table":"Table_table__xpk7y","tableHeader":"Table_tableHeader__HLcE7","tableBody":"Table_tableBody__JuauZ"};